import { autoinject, PLATFORM } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import {
	BaseDialog,
	BaseDialogModel,
	BaseDialogModelDefaults,
} from '~/components/dialog/base-dialog';
import { FieldModel } from '~/models/form-model';

export interface BenefitsPaymentsProcessBatchDialogModel
	extends BaseDialogModel {
	batchRefFieldModel?: FieldModel;
}

const BenefitsPaymentsProcessBatchDialogModellDefaults: BenefitsPaymentsProcessBatchDialogModel =
	{
		...BaseDialogModelDefaults,
		cancelButtonText: 'clickable-elements.abort',
		dialogSize: BaseDialog.DialogSize.EXTRA_SMALL,
		okButtonText: 'clickable-elements.proceed',
	};

@autoinject
export class BenefitsPaymentsProcessBatchDialog extends BaseDialog<BenefitsPaymentsProcessBatchDialogModel> {
	constructor(protected readonly i18n?: I18N, ...rest) {
		super(...rest);
		PLATFORM.moduleName('./benefits-payments-process-batch-dialog');
	}

	public activate(model: BenefitsPaymentsProcessBatchDialogModel) {
		return super.activate(
			model,
			BenefitsPaymentsProcessBatchDialogModellDefaults,
		);
	}
}
